import { compactRecord } from '../shared.js';
export class SdkApiError extends Error {
    constructor(message, status) {
        super(message);
        this.name = 'SdkApiError';
        this.status = status;
    }
}
export class SdkApiClient {
    constructor(publishableKey) {
        this.publishableKey = publishableKey;
    }
    async bootstrap(baseUrl, body) {
        return this.postJson(baseUrl, '/sdk/v1/bootstrap', body);
    }
    async identify(baseUrl, sessionToken, externalId) {
        return this.postJson(baseUrl, '/sdk/v1/identify', {
            session_token: sessionToken,
            external_id: externalId,
        });
    }
    async setUserProperties(baseUrl, sessionToken, userProperties) {
        return this.postJson(baseUrl, '/sdk/v1/user-properties', {
            session_token: sessionToken,
            user_properties: userProperties,
        });
    }
    async heartbeat(baseUrl, body) {
        return this.postJson(baseUrl, '/sdk/v1/session/heartbeat', body);
    }
    async reset(baseUrl, body) {
        return this.postJson(baseUrl, '/sdk/v1/reset', body);
    }
    async prepareCampaign(baseUrl, sessionToken, alias, skipIfAlreadyExposed) {
        return this.postJson(baseUrl, '/sdk/v1/campaigns/prepare', {
            session_token: sessionToken,
            alias,
            skip_if_already_exposed: skipIfAlreadyExposed,
        });
    }
    async postJson(baseUrl, path, body) {
        const response = await fetch(`${baseUrl}${path}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Pillow-SDK-Key': this.publishableKey,
            },
            body: JSON.stringify(compactRecord(body)),
        });
        const text = await response.text();
        const payload = text ? safeParseJson(text) : null;
        if (!response.ok) {
            const message = (payload && typeof payload.error === 'string' && payload.error) ||
                (payload && typeof payload.message === 'string' && payload.message) ||
                `Pillow SDK request failed with status ${response.status}`;
            throw new SdkApiError(message, response.status);
        }
        if (!payload) {
            throw new SdkApiError('Pillow SDK received an empty response body', response.status);
        }
        return payload;
    }
}
function safeParseJson(value) {
    try {
        return JSON.parse(value);
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=client.js.map